import {Component, OnDestroy, OnInit} from '@angular/core';
import {FiltroListagemContrato} from './dto/filtroListagemContrato';
import {TIPOS_DE_OBJETO_DA_LICITACAO} from '../../../_mocks/tiposDeObjetoDaLicitacao';
import {ResultadoFiltragemContrato} from './dto/resultadoFiltragemContrato';
import {DadosPaginacao} from '../../paginacao/dadosPaginacao';
import {BehaviorSubject, Subscription} from 'rxjs';
import {ConfiguracaoPaginacao} from '../../paginacao/configuracaoPaginacao';
import {ContratoService} from '../contratoService';
import {LoadingService} from '../../../services/loading.service';
import {ORGAOS} from '../../../_mocks/orgaos';
import {ActivatedRoute} from '@angular/router';
import mergeObjects from '../../../util/objectHandler';
import {Arquivo} from "../../../_classes/arquivo";
import {LicitacaoService} from "../../../services/licitacao.service";

@Component({
  selector: 'app-listagem-contrato',
  templateUrl: './listagem-contrato.component.html',
  styleUrls: ['./listagem-contrato.component.scss']
})
export class ListagemContratoComponent implements OnInit, OnDestroy {

  orgaos = ORGAOS;
  arquivos: Arquivo[];
  resultadoFiltragemContrato: ResultadoFiltragemContrato;

  /**
   * dados sobre filtragem
   */
  tiposDeObjetoDaLicitacao = TIPOS_DE_OBJETO_DA_LICITACAO;
  maskLicitacao = [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  filtroListagemContrato = new FiltroListagemContrato();

  /**
   * dados sobre paginacao
   */
  ultimoDadoPaginacao: DadosPaginacao;
  subjectPaginacao: BehaviorSubject<ConfiguracaoPaginacao> = new BehaviorSubject<ConfiguracaoPaginacao>(undefined);

  private subscriptions: Subscription[] = [];

  constructor(private contratoService: ContratoService,
              private licitacaoService: LicitacaoService,
              private loadingService: LoadingService,
              private route: ActivatedRoute
  ) {

  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  ngOnInit() {
    this.search();
    this.listenToQueryParams();
  }

  /**
   * Metodo de onde query params devem ser buscados
   */
  listenToQueryParams() {
    this.route.queryParams.subscribe(params => {
      this.changeFiltro(params);
    });
  }

  /**
   * Carrega automaticamente os filtros passados via query param
   */
  changeFiltro(filtroToApply) {

    const getFieldFormatter = (paramName) => {
      const specialFieldsFormatterMap = {
        isCovid19: value => !!value
      }
      const specialFormatter = specialFieldsFormatterMap[paramName];

      return specialFormatter ? specialFormatter : (value) => value;
    }
    mergeObjects(filtroToApply, this.filtroListagemContrato, getFieldFormatter);
    this.search(false);
  }

  onPaginationChange(eventoPaginacao: DadosPaginacao) {
    this.ultimoDadoPaginacao = eventoPaginacao;
    this.search(true);
  }

  search(isPaginationEvent: boolean = false) {
    this.loadingService.changeLoading(true);
    const subscription = this.contratoService
      .getContratosByFilter(this.filtroListagemContrato, this.ultimoDadoPaginacao)
      .subscribe(resultados => {
        this.resultadoFiltragemContrato = resultados;
        this.loadingService.changeLoading(false);
        if (!isPaginationEvent) {
          this.updatePaginationData(resultados.total_resultados);
        }
      }, error => {
        this.loadingService.changeLoading(false);
      });
    this.subscriptions.push(subscription);
  }

  loadFiles(id_licitacao: number) {
    this.arquivos = [];
    this.loadingService.changeLoading(true);
    this.licitacaoService.getArquivosDaLicitacao(id_licitacao).subscribe(arquivos => {
      this.loadingService.changeLoading(false);
      this.arquivos = arquivos;
    });
  }

  updatePaginationData(total_resultados: number) {
    const configuracaoPaginacao = new ConfiguracaoPaginacao();
    configuracaoPaginacao.totalPaginas = total_resultados;
    configuracaoPaginacao.paginaAtual = this.ultimoDadoPaginacao ? this.ultimoDadoPaginacao.page : 0;

    this.subjectPaginacao.next(configuracaoPaginacao);
  }

  download(arquivo: Arquivo) {
    this.loadingService.changeLoading(true);
    window.open(arquivo.valor);
  }

  exportar(tipoExportacao: string) {

    const downloadFnc = uri => {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = uri;
      a.download = 'olah';
      a.click();
      a.remove();
    }

    const uri = this.contratoService.getExportarURI(tipoExportacao, this.filtroListagemContrato, this.ultimoDadoPaginacao);
    downloadFnc(uri);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/contrato/listagem-contrato/listagem-contrato.component.ts